import { useCallback, useMemo } from "react";
import { TextField } from "@mui/material";

import Author from "components/Table/Author";

import Constants from "utils/Constants";
import { blockInvalidChar } from "utils/methods/methods";

function QhseData(qhseDprList, options = {}) {
  const { editable = false, onChange } = options;

  const capitalizeFirstLetter = useCallback((text) => {
    if (typeof text !== "string" || text.length === 0) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }, []);

  const handleChange = useCallback(
    (kpiId, field, value) => {
      if (onChange) {
        onChange(kpiId, field, value);
      }
    },
    [onChange]
  );

  const qhseRows = useMemo(() => {
    if (!qhseDprList) return [];

    return qhseDprList.map((item, index) => {
      const identifier =
        item?.kpiId || item[Constants.MONGOOSE_ID] || item?.type || item?.name || index;
      const rawName = item?.name || item?.type || "-";
      const displayName = capitalizeFirstLetter(rawName);
      const isIncidentType =
        typeof rawName === "string" && rawName.trim().toLowerCase() === "incident";
      const fontWeight = "normal";

      const isKpiRow = Boolean(item?.kpiId);

      const renderNumberCell = (field) => {
        const value = item?.[field] ?? "";

        // Always render as read-only text for non-KPI rows or when explicitly read-only
        if (!editable || !isKpiRow) {
          return <Author name={value === 0 ? "-" : value || "-"} style={{ fontWeight }} />;
        }

        // Render editable input only for "today" field
        return (
          <TextField
            type="number"
            size="small"
            value={value === 0 ? 0 : value || ""}
            onChange={(e) => {
              const val = e.target.value;
              if (val < 0) return; // double check
              handleChange(identifier, field, val);
            }}
            onKeyDown={blockInvalidChar}
            inputProps={{ min: 0 }}
            sx={{ maxWidth: 120 }}
          />
        );
      };

      return {
        srNo: <Author name={index + 1} style={{ fontWeight }} />,
        type: (
          <Author name={displayName} style={{ fontWeight: isIncidentType ? "bold" : fontWeight }} />
        ),
        previous: renderNumberCell("previous"),
        today: renderNumberCell("today"),
        total: renderNumberCell("total"),
        open: renderNumberCell("open"),
      };
    });
  }, [editable, qhseDprList, handleChange]);

  const qhseColumns = useMemo(
    () => [
      { Header: "No.", accessor: "srNo", width: "5%" },
      { Header: "Type", accessor: "type", width: "40%" },
      { Header: "Previous", accessor: "previous", align: "left", width: "15%" },
      { Header: "Today", accessor: "today", align: "left", width: "15%" },
      { Header: "Total", accessor: "total", align: "left", width: "15%" },
      { Header: "Open", accessor: "open", align: "left", width: "15%" },
    ],
    []
  );

  return {
    qhseColumns,
    qhseRows,
  };
}

export default QhseData;
